import getCombatantById from './getCombatantById'
//---------------------------
// is valid combatant action
//---------------------------
export default function isValidCombatantAction(id, action) {
  let c = getCombatantById(id)
  //--------------------
  // check action value
  //--------------------
  switch (action) {
    //----------
    // 1. delay
    //----------
    case 'delay':
      if (!c.delayed && c.counters == 0) {
        return true
      } else {
        return false
      }
    //----------
    // 6. shoot
    //----------
    case 'shoot':
    case 'ranged':
      if (c.ranged && c.counters == 0) {
        return true
      } else {
        return false
      }
    //-----------
    // 7. reload
    //-----------
    case 'reload':
      if (c.ranged && c.counters == 0) {
        return true
      } else {
        return false
      }
    //-----------
    // 8. aim
    //-----------
    case 'aim':
      if (c.ranged && c.counters == 0) {
        return true
      } else {
        return false
      }
    //-----------
    // 10. magic
    //-----------
    case 'magic_action':
      if (c.magic && c.counters == 0) {
        return true
      } else {
        return false
      }
    //---------------------
    // 11. remove_counters
    //---------------------
    case 'remove_counter':
      if (c.counters > 0) {
        return true
      } else {
        return false
      }
    //--------------------
    // 12. special_action
    //--------------------
    case 'special_action':
      if (c.special_action && c.counters == 0) {
        return true
      } else {
        return false
      }
    //----------------
    // return default
    //----------------
    default:
      if (c.counters == 0) {
        return true
      } else {
        return false
      }
  }
}
